export { VolumeUp as default } from './VolumeUp';
